module.exports = __webpack_public_path__ + "img/Napoleon Bracy Jr.8fdaca74.jpg";